import { Flex } from "@chakra-ui/react";

interface ConteudoButtonManutencaoProps {
  color: string;
  icon: any;
  bgColor: string;
}

export default function ConteudoButtonManutencao({
  bgColor,
  color,
  icon,
}: ConteudoButtonManutencaoProps) {
  return (
    <Flex
      bg={bgColor}
      rounded="full"
      border={`solid 1px ${color}`}
      w={35}
      h={35}
      align="center"
      justifyContent="center"
    >
      {icon}
    </Flex>
  );
}
